import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationSummaryComponent } from './component/transport-registration-summary.component';
import { CommonUIModule } from '@sdbn/common';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportRegistrationSummaryComponent
  ],
  imports: [
    CommonModule,

    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,
    CommonUIModule
  ]
})
export class TransportRegistrationSummaryModule { }
